'use client'

import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { TicketEvent } from '@/payload-types'
import { useState } from 'react'
import { Label } from '@/components/ui/label'
import { useRouter } from 'next/navigation'
import QuantityField from '@/components/QuantityField'
import formatCurrency from '@/lib/common/utils/formatCurrency'
import ProgressBar from '@/components/ui/progress-bar'

export type BuyTicketsFormState = {
  email: string
  quantity: string
  errors?: Record<string, string | undefined>
  success?: boolean
  message?: string
}

interface BuyTicketsProps {
  ticketEvent: TicketEvent
  stock: number
  sold: number
}

export const BuyTickets = ({ ticketEvent, stock, sold }: BuyTicketsProps) => {
  const [quantity, setQuantity] = useState(ticketEvent.minOrder)
  const router = useRouter()

  return (
    <div className={'p-4 border-dashed rounded-2xl border-2 border-primary max-w-lg my-4'}>
      <h4>Bestel nu je tickets</h4>
      <ProgressBar value={sold} max={stock}>
        nog {stock - sold}/{stock} tickets beschikbaar
      </ProgressBar>
      <p className={'mb-1'}>
        Bestel hier je tickets voor <b>{ticketEvent.name}</b>.
      </p>
      <div>
        <Input type={'hidden'} name={'ticketEventId'} value={ticketEvent.id} />

        <Label htmlFor={'quantity'}>
          Aantal {/*(max. {String(ticketEvent.maxOrder)})*/}
          <QuantityField
            id={'quantity'}
            defaultValue={quantity}
            min={ticketEvent.minOrder}
            max={ticketEvent.maxOrder}
            onChange={(value) => setQuantity(value)}
          />
        </Label>

        <div className={'mb-2 flex gap-2 items-baseline'}>
          <Button
            onClick={() => router.push(`/tickets/${ticketEvent.slug}/bestellen?aantal=${quantity}`)}
            disabled={
              quantity < ticketEvent.minOrder || quantity > ticketEvent.maxOrder || stock === 0
            }
          >
            Bestellen
          </Button>
          <span>Totaal:</span> &euro;{formatCurrency(ticketEvent.price * quantity)}
        </div>
      </div>
    </div>
  )
}
